import { render } from "./TextUs.vue?vue&type=template&id=7b0a5bf5&scoped=true"
import script from "./TextUs.vue?vue&type=script&lang=js"
export * from "./TextUs.vue?vue&type=script&lang=js"

import "./TextUs.vue?vue&type=style&index=0&id=7b0a5bf5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0a5bf5"],['__file',"src/Components/Shared/TextUs/TextUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b0a5bf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b0a5bf5', __exports__)) {
    api.reload('7b0a5bf5', __exports__)
  }
  
  module.hot.accept("./TextUs.vue?vue&type=template&id=7b0a5bf5&scoped=true", () => {
    api.rerender('7b0a5bf5', render)
  })

}


export default __exports__